import { getChartConfiguration } from "./chart-configuration"
import { views } from "./helpers/views"
import { createSingleGradient } from "./helpers/gradient"
import { colors } from "./colors"

const getSelfConsumptionChartConfiguration = (date, view, lang, type, fullscreen, debug = false, environment = "apps", timezone) => {
    let chartConfiguration = getChartConfiguration(date, view, lang, type, fullscreen, debug, environment, false, timezone)

    if (views[view] <= views.day) {
        // Stack the day graph
        chartConfiguration.options.scales.yAxes[0].stacked = true
    }

    // all datasets
    for(const i in chartConfiguration.data.datasets) {
        chartConfiguration.data.datasets[i].spanGaps = true
        chartConfiguration.data.datasets[i].barThickness =
            fullscreen === false && views[view] === views.year ? 6 : 10
    }

    // purple "imported from the grid"
    chartConfiguration.data.datasets[0] = {
        ...chartConfiguration.data.datasets[0],
        order: views[view] <= views.day ? 2 : 1,
        fill: 1,
        ...views[view] > views.day && {
            borderColor: colors.power_import.border
        },
    }

    // green "exported to the grid"
    chartConfiguration.data.datasets[1] = {
        ...chartConfiguration.data.datasets[1],
        order: views[view] <= views.day ? 1 : 2,
        fill: 2,
        ...views[view] > views.day && {
            borderColor: colors.power_export.border
        },
    }

    // blue "self consumption"
    chartConfiguration.data.datasets[2] = {
        ...chartConfiguration.data.datasets[2],
        order: 0,
        fill: 'origin',
        ...views[view] > views.day && {
            borderColor: colors.power_self_consumption.border,
        },
    }

    // data labels
    chartConfiguration.options.plugins.datalabels.font.size = '10'

    chartConfiguration.data.datasets[0].datalabels.align = '-135' // purple
    chartConfiguration.data.datasets[1].datalabels.align = '-45'  // green
    chartConfiguration.data.datasets[2].datalabels.align = '-135'  // blue

    // Give data label on top of middle purple import bar a bit more height when colliding
    chartConfiguration.data.datasets[0].datalabels.padding = (context) => {
        const { dataIndex, chart, dataset } = context

        const yScale = chart.scales['y-axis-0']

        // first bar in blue
        const selfConsumptionAmount = chart.data.datasets[2].data[dataIndex].y

        // second bar in purple
        const importAmount = dataset.data[dataIndex].y

        const differ = importAmount / selfConsumptionAmount

        const heightDiffer = 2.2 * (yScale.getPixelForValue(importAmount) - yScale.getPixelForValue(selfConsumptionAmount))
        const offsetTop = 20 + Math.max(0, heightDiffer)

        return {
            top: differ <= 1.30 ? offsetTop : 0,
            right: -2,
            bottom: 0,
            left: 0
        }
    }

    // Create gradients
    chartConfiguration.plugins[0].afterLayout = (chart, options) => {
        // purple "imported from the grid"
        chart.data.datasets[0].backgroundColor = createSingleGradient(
            chart,
            0,
            colors.power_import.gradient_start,
            colors.power_import.gradient_end,
        )

        // green "exported to the grid"
        chart.data.datasets[1].backgroundColor = createSingleGradient(
            chart,
            1,
            colors.power_export.gradient_start,
            colors.power_export.gradient_end,
        )

        // blue "self consumption"
        chart.data.datasets[2].backgroundColor = createSingleGradient(
            chart,
            2,
            colors.power_self_consumption.gradient_start,
            colors.power_self_consumption.gradient_end,
        )
    }

    return chartConfiguration
}

export { getSelfConsumptionChartConfiguration }
